module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAADPSURBVFhH7ZfbDYMwDEUD/2WyrsBy7QhlMhYospRUaYgdPwIJEkdC5AN8L9fmNTw+r69ryOj3zWAnsD5nv+IxLW+/oikakAqnlIyQLbCKA6UaqIEa4gGqVtYAVxzi5fYaq7kzIBEPWEz8GdCIB7QmyCE8g58B7tUDuWO156sTiItIxFNMLQBhizjQzwxIgamPNy3XTaAWt4HbQD8GLPeylFirrxackUKqsUvgSBO52uhnufUtl4JdGDoDNZOgapFDWMNEqUb/v2ZH0/g54NwGeYNTS0fFNHsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/notifications2.png
// module id = CkEo
// module chunks = 1